module.exports = "<section id=page-container transition=nav class=initial _v-7193d8b0=\"\"><a v-for=\"target in targets\" v-link=target.link v-bind:style=\"{ backgroundImage: 'url(' + target.background + ')' }\" class=target-section _v-7193d8b0=\"\"><div class=title _v-7193d8b0=\"\"><h1 _v-7193d8b0=\"\">{{target.sub}}</h1></div><div class=image _v-7193d8b0=\"\"><img v-bind:src=target.img _v-7193d8b0=\"\"></div></a></section>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7193d8b0!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./public/_src/_vue/Nav.vue
 ** module id = 42
 ** module chunks = 0
 **/